import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { Skeleton } from 'base-ui'

import { crossSellGetFormattedPrice } from '../../../cross-sell'
import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'
import { cartIntermediateCrossSellAccessorGetProductDiscount } from '../../model/cartIntermediateCrossSellAccessorGetProductDiscount'
import { cartIntermediateCrossSellAccessorIsSellerShopApotheke } from '../../model/cartIntermediateCrossSellAccessorIsSellerShopApotheke'

type CartIntermediateSpecialOffersProductDiscountWithPriceProps = {
  product?: CrossSellProduct
}

export const CartIntermediateSpecialOffersProductDiscountWithPrice: FC<
  CartIntermediateSpecialOffersProductDiscountWithPriceProps
> = ({ product }) => {
  const intl = useIntl()
  const { tenant } = useGlobalConfigContext()
  if (!product) {
    return (
      <div className="min-h-[calc(var(--type-scale-l-line-height)+var(--type-scale-s-line-height)+var(--type-scale-s-line-height))]">
        <Skeleton className="mx-auto w-4/5" />
      </div>
    )
  }
  const isSellerShopApotheke =
    cartIntermediateCrossSellAccessorIsSellerShopApotheke(product.sellerId)
  const discount = cartIntermediateCrossSellAccessorGetProductDiscount(product)

  return (
    <div className="flex flex-col gap-1 pt-1">
      <div className="flex flex-row content-center gap-2">
        <span className="flex rounded-2xl bg-light-tertiary px-2 py-1 text-center font-mono font-medium text-dark-primary-max">
          {discount}
        </span>
        <span className="whitespace-nowrap text-2xl font-bold text-dark-brand">
          {crossSellGetFormattedPrice(product.price, intl)}
        </span>
      </div>
      <span className="text-xs text-dark-primary-strong">
        {crossSellGetFormattedPrice(product.new_baseprice, intl)}
      </span>
      <span className="text-s text-dark-primary-max">
        {isSellerShopApotheke
          ? intl.formatMessage({ id: 'general.label.listPrice' })
          : intl.formatMessage({ id: 'general.label.miraklListPrice' })}

        <span className="pl-1 line-through">
          {product.reduced === 'true' &&
            crossSellGetFormattedPrice(product.oldprice, intl, {
              // on IT superscript is not in response, we need to force adding it for oldprice
              isItalianStrikethrough: tenant === TENANT.IT,
            })}
        </span>
      </span>
    </div>
  )
}
